import '../scss/style.scss';
import "bootstrap";
import {Modal} from "bootstrap";
import jQuery from 'jquery';
import 'slick-carousel';
import {startPageOnTop} from "./utilities";
import {DesktopSiteMenu, MobileSiteMenu} from "./site-menu";
import {debounce} from "./debounce";
import {
    productsCarousel,
    productsCategoriesCarousel,
    productGallery,
    relatedProducts,
    familyCarousel,
    sliderCarousel,
} from "./carousels";
import googleMap from "./googleMap";
import baguetteBox from 'baguettebox.js'; // Lightbox
import lozad from 'lozad'; // Lazy load
import imagesLoaded from 'imagesloaded';
import MatchHeight from 'vanilla-js-match-height';
import Lenis from '@studio-freight/lenis'; // Smooth Scroll
import ScrollObserver from "./scroll-observer"; // Scroll Reveal
import Parallax from "./parallax";
import SplitType from 'split-type'; // Text split animation
import {hfproFrameByFrame} from "./hfpro-frame-by-frame";
import {speedboaFrameByFrame} from "./speedboa-frame-by-frame";
import imageComparator from "./image-comparator"
import {animateCubicBezier} from "./utils";

(function ($) {
    // Match media breakpoints
    const matchMediaLGDown = window.matchMedia('(max-width: 991px)');
    const matchMediaLGUp = window.matchMedia('(min-width: 992px)');
    const matchMediaXlDown = window.matchMedia('(max-width: 1199px)');
    const matchMediaXlUp = window.matchMedia('(min-width: 1200px)');

    // Smooth Scroll (Desktop only)
    if (matchMediaXlUp.matches) {
        const smooth = new Lenis()

        /*smooth.on('scroll', (e) => {
            console.log(e)
        })*/
        function raf(time) {
            smooth.raf(time)
            requestAnimationFrame(raf)
        }

        requestAnimationFrame(raf)
    }

    // Force to start page on top
    startPageOnTop();

    /**
     * Site menu
     */
        // Main header
    const mainHeader = document.querySelector('#main-header');
    const mainHeaderNavbar = mainHeader.querySelector('.navbar');
    const mobileOffcanvas = mainHeader.querySelector('#offcanvas-mobile');
    if (mainHeaderNavbar) {
        new DesktopSiteMenu(mainHeaderNavbar);
    }
    if (mobileOffcanvas) {
        new MobileSiteMenu(mobileOffcanvas);
    }

    /**
     * Detect scroll direction
     * @returns {boolean}
     */
    let lastScrollTop = 0;
    const isScrollingDown = () => {
        let goingDown = false;
        let st = window.scrollY || document.documentElement.scrollTop;
        goingDown = st > lastScrollTop;
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        return goingDown;
    };

    /**
     * Google map
     */
    const hasMap = document.querySelector('.has-map');
    if (hasMap) googleMap()

    /**
     * Toggle scroll direction body and navbar theme classes
     * Math.sign(window.scrollY) !== -1 for detecting Safari negative over-scroll
     */
    const handleBodyClassByScroll = () => {
        if (!document.body.classList.contains('mega-dropdown-shown')) {
            if (isScrollingDown()) {
                document.body.classList.remove("scroll-up");
                document.body.classList.add("scroll-down");
            } else if (Math.sign(window.scrollY) !== -1) {
                document.body.classList.add("scroll-up");
                document.body.classList.remove("scroll-down");
                mainHeaderNavbar.classList.replace('navbar-dark', 'navbar-light')
            }
            if (window.scrollY < 100 && Math.sign(window.scrollY) !== -1) {
                document.body.classList.remove("scroll-up");
                mainHeaderNavbar.classList.remove('navbar-dark', 'navbar-light');
                if (mainHeaderNavbar.dataset.theme) {
                    mainHeaderNavbar.classList.add(mainHeaderNavbar.dataset.theme);
                }
            }
        }
    };
    window.addEventListener("scroll", handleBodyClassByScroll);

    /**
     *  Hero slide vertical line height
     */
    const hero = document.querySelector('.hero');
    const heroWithImgContent = document.querySelector('.hero-img-content');
    const heroSlides = document.querySelectorAll('.hero-slide');
    const setHeroSlideVerticalLineHeight = () => {
        if (!hero || !heroSlides || heroSlides.length === 0) {
            return;
        }
        heroSlides.forEach(heroSlide => {
            const heroSlideVerticalLine = heroSlide.querySelector('.hero-slide__vertical-line');
            if (heroWithImgContent) {
                heroSlideVerticalLine.style.height = (hero.clientHeight - heroWithImgContent.clientHeight) + 'px';
            } else if (heroSlideVerticalLine) {
                heroSlideVerticalLine.style.height = (hero.clientHeight - heroSlide.clientHeight) + 'px';
            }
        });
    }

    /**
     * Product Gallery
     * @type {exports|HTMLElement|*}
     */
        // Product Gallery
    const productGallerySelector = '.product-gallery';
    const $productGallery = $(productGallerySelector);
    const setProductGallery = () => {
        if (
            $productGallery.length
            && matchMediaLGDown.matches
            && !$productGallery.hasClass('slick-initialized')
        ) {
            productGallery($productGallery);
        }
    }

    /**
     *  Lightbox
     */
    const setLightBox = () => {
        if ($productGallery && $productGallery.length) {
            if (matchMediaLGUp.matches && !$productGallery.hasClass('slick-initialized')) {
                baguetteBox.run(productGallerySelector);
                $productGallery.find('.product-gallery__item').removeClass('pe-none');
            } else {
                $productGallery.find('.product-gallery__item').addClass('pe-none');
            }
        }
    }

    /**
     * Read more
     * @type {NodeListOf<Element>}
     */
        // Read more
    const jsReadMoreItems = document.querySelectorAll('.js-read-more');
    if (jsReadMoreItems && jsReadMoreItems.length) {
        import('./read-more').then(module => {
            module.ReadMore.init();
        });
    }

    const simpleGallery = document.querySelectorAll('.simple-gallery');
    if (simpleGallery && simpleGallery.length) {
        baguetteBox.run('.simple-gallery');
    }

    // Skis product card
    const skisProductCards = document.querySelectorAll('.product-card--skis');
    const replaceSkisProductCardClass = () => {
        if (skisProductCards && skisProductCards.length) {
            skisProductCards.forEach(productCard => {
                if (
                    productCard.classList.contains('product-card--vertical-zoom')
                    && !productCard.classList.contains('product-card--square-thumb')
                    && matchMediaXlDown.matches
                ) {
                    productCard.classList.replace('product-card--vertical-zoom', 'product-card--vertical');
                } else if (productCard.classList.contains('product-card--vertical') && matchMediaXlUp.matches) {
                    productCard.classList.replace('product-card--vertical', 'product-card--vertical-zoom');
                }
            });
        }
    }

    /**
     * Handle resize
     * @param callbacks
     */
    function handleOnResize(callbacks) {
        if (!callbacks || callbacks.length === 0) {
            return;
        }
        callbacks.forEach(callback => callback());
    }

    let onResizeCallbacks = [
        setHeroSlideVerticalLineHeight,
        setProductGallery,
        setLightBox,
        replaceSkisProductCardClass
    ];
    // on page load
    handleOnResize(onResizeCallbacks);
    // on page resize
    const onResize = debounce((timeout = 300) => handleOnResize(onResizeCallbacks));
    window.addEventListener("resize", onResize);

    /**
     * Carousel Products Categories
     * @type {exports|HTMLElement|*}
     */
    const $productsCategoriesCarousel = $('.products-categories-carousel');
    if ($productsCategoriesCarousel) {
        productsCategoriesCarousel($productsCategoriesCarousel);
    }

    /**
     * Carousel Products
     * @type {exports|HTMLElement|*}
     */
    const $productsCarousel = $('.products-carousel');
    if ($productsCarousel) {
        productsCarousel($productsCarousel);
    }

    /**
     * Carousel Products
     * @type {exports|HTMLElement|*}
     */
    const $lightboxCarousel = $('.lightbox-carousel');
    if ($lightboxCarousel) {
        productsCarousel($lightboxCarousel);
        baguetteBox.run('.lightbox-carousel');
    }

    /**
     * Related products
     * @type {exports|HTMLElement|*}
     */
    const $relatedProducts = $('.related-products');
    if ($relatedProducts) {
        relatedProducts($relatedProducts);
    }

    /**
     * Family carousel
     * @type {exports|HTMLElement|*}
     */
    const $familyCarousel = $('.family-carousel');
    if ($familyCarousel) {
        familyCarousel($familyCarousel);
    }

    /**
     * Slider carousel
     * @type {exports|HTMLElement|*}
     */
    const $sliderCarousel = $('.slider-carousel');
    if ($sliderCarousel) {
        sliderCarousel($sliderCarousel);
    }

    /**
     * Lazy load
     */
    const lazyItems = document.querySelectorAll('.lazy');
    if (lazyItems && lazyItems.length) {
        let options = {
            loaded: function (el) {
                imagesLoaded(el, function () {
                    el.parentNode.classList.add('media-loaded');
                });
                if (!el.alt && el.dataset.alt) {
                    el.alt = el.dataset.alt;
                }
            }
        };
        const observer = lozad(lazyItems, options);
        observer.observe();
    }

    /**
     * Videos HTML5
     * @type {NodeListOf<Element>}
     */
    const videos = document.querySelectorAll('video');
    if (videos && videos.length) {
        import('./video').then(module => {
            module.default(videos);
        });
    }

    /**
     *  Stories : Old load more script
     */
    if (document.body.classList.contains('stories')) {
        let page = 1;
        $("body").on('click', '#loadMoreStory', function () {
            $('body').append('<div id="loader"></div>');
            const load = parseInt($("#loadMoreStory").data("load"));
            $.get($(this).attr("href"), {page: load}, function (data) {
                var lastPage = Number($("<div>" + data + "</div>").find("input[name=lastPage]").val());
                if (load >= lastPage) {
                    $("#loadMoreStory").remove();
                } else {
                    $("#mancanti").text(Number($("#mancanti").text()) - 8);
                }
                $("#main-stories").append(data);
                load++;
                $("#loadMoreStory").data("load", load);
                $('#loader').fadeOut().remove();
            });
            return false;
        });
    }

    /**
     * Handle size buttons active (accessory detail)
     * @type {NodeListOf<Element>}
     * {{-- TODO @michael | ajax call --}}
     */
    const sizeButtonsContainer = document.querySelector('.size-buttons');
    const sizeButtons = sizeButtonsContainer?.querySelectorAll('button');
    const quantityWrap = document.querySelector('.quantity-wrap');
    if (sizeButtonsContainer && sizeButtons && sizeButtons.length && quantityWrap) {
        sizeButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                sizeButtonsContainer.querySelector('.active')?.classList.remove('active');
                e.currentTarget.classList.add('active');
                if (quantityWrap.querySelector('.btn--minus').hasAttribute("disabled")) {
                    quantityWrap.querySelector('.btn--minus').removeAttribute("disabled");
                }
                if (quantityWrap.querySelector("input[type=number]").hasAttribute("disabled")) {
                    quantityWrap.querySelector("input[type=number]").removeAttribute("disabled");
                }
                if (quantityWrap.querySelector('.btn--plus').hasAttribute("disabled")) {
                    quantityWrap.querySelector('.btn--plus').removeAttribute("disabled");
                }
                if (quantityWrap.nextElementSibling.hasAttribute("disabled")) {
                    quantityWrap.nextElementSibling.removeAttribute("disabled");
                }
            });
        });
    }

    /**
     * Firefox :has polyfill families mega-dropdown
     * @type {NodeListOf<Element>}
     */
    const megaDropdownCategories = document.querySelectorAll('.mega-dropdown__categories');
    if (megaDropdownCategories && megaDropdownCategories.length) {
        megaDropdownCategories.forEach(megaDropdownCategory => {
            const hasFamilies = megaDropdownCategory.querySelectorAll('.mega-dropdown__families');
            if (hasFamilies && hasFamilies.length) {
                megaDropdownCategory.classList.add('js-has-families');
            }
        });
    }

    /**
     * Firefox :has polyfill families products grid boots
     * @type {NodeListOf<Element>}
     */
    const productsGridBoots = document.querySelector('.products-grid--boots');
    if (productsGridBoots) {
        const productsGridItemHighlight = productsGridBoots.querySelector('.products-grid__item--highlight');
        if (productsGridItemHighlight) {
            productsGridBoots.classList.add('js-has-highlight');
        }
    }

    /**
     * Handle search focus
     * @type {HTMLElement}
     */
    const searchInput = document.querySelector('#search-input');
    if (searchInput && matchMediaXlUp.matches) {
        document.addEventListener('megaDropdown.shown', (e) => {
            if (typeof e.detail !== "undefined" && e.detail === '#dropdown-search') {
                searchInput.focus();
            }
        });
    }

    /**
     * Parallax
     * @type {NodeListOf<Element>}
     */
    const parallaxes = document.querySelectorAll('.parallax');
    if (parallaxes && parallaxes.length) {
        Parallax(parallaxes);
    }

    /**
     * Scroll Reveal
     * @type {NodeListOf<Element>}
     */
    const revealItems = document.querySelectorAll('.has-reveal');
    if (revealItems && revealItems.length) {
        ScrollObserver(revealItems);
        /*import('./scroll-observer').then(module => {
            module.default(revealItems);
        });*/
    }

    /**
     * Handle product anchors nav items visibility
     * @type {NodeListOf<Element>}
     */
    const productAnchorsNavLinks = document.querySelectorAll('.product-anchors-nav .nav-link');
    if (productAnchorsNavLinks.length) {
        productAnchorsNavLinks.forEach(navLink => {
            const navLinkHref = navLink.getAttribute('href');
            const section = document.querySelector(navLinkHref);
            if (!section) {
                navLink.parentNode.classList.add('d-none')
            }
        });
    }

    const gridCardsContainer = document.querySelector('.grid-cards');
    if (gridCardsContainer) {
        const gridCardsItems = gridCardsContainer.querySelectorAll('article');
        if (gridCardsItems.length) {
            gridCardsContainer.classList.add(`grid-cards--has-${gridCardsItems.length}`);
        }
    }

    /**
     * Match height
     * @type {NodeListOf<Element>}
     */
    const jsMatchHeightItems = document.querySelectorAll('.js-match-height');
    if (jsMatchHeightItems && jsMatchHeightItems.length) {
        new MatchHeight('.js-match-height', {
            timeOut: 500
        });
    }

    /**
     * SF Chat triggers
     * @type {NodeListOf<Element>}
     */
    const sfChatTriggers = document.querySelectorAll('.sf-chat-trigger');
    if (sfChatTriggers.length) {
        sfChatTriggers.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                $('.embeddedServiceHelpButton button').trigger('click');
            });
        });
    }

    /**
     * Split text animation
     * @type {NodeListOf<Element>}
     */
    const hasSplitTextItems = document.querySelectorAll('.split-text');
    if (hasSplitTextItems && hasSplitTextItems.length) {
        hasSplitTextItems.forEach(item => {
            const text = new SplitType(item, {types: 'words'});
            if (text.words.length) {
                text.words.forEach((word, index) => {
                    word.classList.add('has-reveal', 'has-reveal--fadeInWord', 'revealed');
                });
                if (item.previousElementSibling) {
                    item.previousElementSibling
                }
            }
        })
    }

    /**
     * hfpro Frame by Frame
     */
    if (document.body.classList.contains('hfpro')) {
        hfproFrameByFrame();
    }

    /**
     * speedboa Frame by Frame
     */
    if (document.body.classList.contains('speed-boa')) {
        speedboaFrameByFrame();
    }

    /**
     * MM
     */
    if ($('.compare')) {
        $('.btn-compare-discover').on('click', function () {
            $('.btn-compare-discover').removeClass('compare-active');
            $(this).addClass('compare-active');
        });

        $('.btn-compare-radio').on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            let position = $('.btn-compare-discover.compare-active').data('index');
            let sku = $(this).find('input').val();
            let route = $(this).find('input').attr('data-route');
            $.ajax({
                url: route,
                method: 'GET',
                data: {
                    code: sku,
                    position: position
                },
                success: function (data) {
                    if ($('tr.radius')) {
                        $('tr.radius').find("td[data-index='" + data.position + "']").html(data.radius)
                    }
                    if ($('tr.core')) {
                        $('tr.core').find("td[data-index='" + data.position + "']").html(data.core)
                    }
                    if ($('tr.construction')) {
                        $('tr.construction').find("td[data-index='" + data.position + "']").html(data.construction)
                    }
                    if ($('tr.rocker')) {
                        $('tr.rocker').find("td[data-index='" + data.position + "']").html(data.rocker)
                    }
                    if ($('tr.soles')) {
                        $('tr.soles').find("td[data-index='" + data.position + "']").html(data.soles)
                    }
                    if ($('tr.cuff')) {
                        $('tr.cuff').find("td[data-index='" + data.position + "']").html(data.cuff)
                    }
                    if ($('tr.liner')) {
                        $('tr.liner').find("td[data-index='" + data.position + "']").html(data.liner)
                    }
                    if ($('tr.volume')) {
                        $('tr.volume').find("td[data-index='" + data.position + "']").html(data.volume)
                    }
                    if ($('tr.last')) {
                        $('tr.last').find("td[data-index='" + data.position + "']").html(data.last)
                    }
                    if ($('tr.product-name')) {
                        $('tr.product-name').find("td[data-index='" + data.position + "']").html(data.product_name)
                    }
                    if ($('tr.weight')) {
                        $('tr.weight').find("td[data-index='" + data.position + "']").html(data.weight)
                    }
                    if ($('tr.sidecut')) {
                        $('tr.sidecut').find("td[data-index='" + data.position + "']").html(data.sidecut)
                    }
                    if ($('tr.route')) {
                        $('tr.route').find("td[data-index='" + data.position + "'] a").attr('href', data.route)
                    }
                    if ($('tr.tech')) {
                        $('tr.tech').find("td[data-index='" + data.position + "']").html(data.technologies)
                    }
                    if ($('tr.header')) {
                        $('tr.header').find("th[data-index='" + data.position + "'] a").attr('href', data.route)
                        $('tr.header').find("th[data-index='" + data.position + "'] .product-name").html(data.product_name)
                        $('tr.header').find("th[data-index='" + data.position + "'] a img").remove()
                        $('tr.header').find("th[data-index='" + data.position + "'] a").append(data.image)
                    }
                    $('#compareModal .btn-close').click();
                },
                error: function (data) {

                }

            });
        });
    }
    if ($('#sel_size button')) {
        let routeToken = $("#route_token").val();
        let routeAddCart = $("#route_add_cart").val();
        $("#sel_size button").click(function () {
            $("#product_sku").val($(this).attr("data-shopify-id"));
            //creo le opzioni per la quantità in base alla disponibilità
            // let i;
            $(".quantity").empty();
            $(".quantity").attr("max", $(this).attr("data-stock"));
            /*for (i = 0; i < $(this).attr("data-stock"); i++) {
                $(".quantity").setAttribute("max", $(this).attr("data-stock"));
            }*/
            // $(".quantity").removeAttr("disabled");
        });

        $('#add-to-cart').on('click', function () {
            $('.alert-success').addClass('d-none');
            $('.alert-danger').addClass('d-none');

            var shopifyId = $('#product_sku').val();
            var qnt = $('.quantity').val();
            $('.shopify-loading').removeClass('d-none');

            if (shopifyId === '') {
                $('.alert-error').html('Select a Size');
            }
            if (qnt == 0 || qnt == '') {
                $('.alert-quantity').html('Select quantity');
                $('.alert-quantity').removeClass('d-none');
            }
            if (qnt !== '' && qnt !== 0 && shopifyId !== '') {
                $.ajax({
                    url: routeToken,
                    method: 'GET',
                    success: function (data) {
                        $.ajaxSetup({
                            headers: {
                                'X-CSRF-TOKEN': data
                            }
                        });
                        $.ajax({
                            url: routeAddCart,
                            method: 'POST',
                            data: {
                                shopifyId: shopifyId,
                                quantity: qnt
                            },
                            success: function (data) {
                                $('.alert-success').text(data.message);
                                $('.alert-success').removeClass('d-none');
                                $('#add-to-cart').text(data.message)
                                $('#add-to-cart').removeClass('btn-primary');
                                $('#add-to-cart').addClass('btn-outline-dark');
                                $('.shopify-loading').addClass('d-none');
                                $('.cart-notify').removeClass('d-none');
                                $('.cart-notify').text(data.quantity)
                                setTimeout(function () {
                                    $('#add-to-cart').removeClass('btn-outline-dark');
                                    $('#add-to-cart').addClass('btn-primary');
                                    $('#add-to-cart').text('Add to Cart')
                                }, 3000);
                            },
                            error: function () {
                                $('.shopify-loading').addClass('d-none');
                                $('.alert-danger').text(data.message);
                                $('.alert-danger').removeClass('d-none');
                            }
                        });
                    }
                });
            }
        });
    }

    const $btnPlus = $('.btn--plus');
    if ($btnPlus) {
        $btnPlus.on('click', function () {
            const $quantity = $(this).parent().children('.quantity');
            const $quantityValue = parseInt($quantity.val(), 10);
            const $quantityMax = $quantity.attr('max');
            $(this).removeAttr('disabled')
            if (($quantityValue + 1) > 0) {
                $(this).parent().find('.btn--minus').removeAttr('disabled')
            }
            if ($quantityValue == $quantityMax) {
                $(this).attr('disabled', 'disabled')
            }
            if ($quantityValue < $quantityMax) {
                $quantity.attr('value', $quantityValue + 1);
                $quantity.val($quantityValue + 1);
                if (($quantityValue + 1) == $quantityMax) {
                    $(this).attr('disabled', 'disabled')
                }
            } else {
                $(this).attr('disabled', 'disabled')
            }
            if ($('body').hasClass('checkout')) {
                let spinner = $(this).parents('.cart-list').find('.shopify-loading');
                if ($quantityValue > 0) {
                    shopifyUpdateQuantity($quantity, $(this).parent().children('.shopify_id'), $(this).parent().children('.cart_line'), spinner);
                } else {
                    shopifyRemoveProduct($(this).parent().children('.shopify_id').val(), $(this).parent().children('.cart_line').val(), $(this).parent().children('.shopify_id').val());
                }
            }

        })
    }
    const $btnMinus = $('.btn--minus');
    if ($btnMinus) {
        $btnMinus.on('click', function () {
            const $quantity = $(this).parent().children('.quantity');
            const $quantityMax = $quantity.attr('max');
            const $quantityValue = parseInt($quantity.val(), 10);
            $(this).removeAttr('disabled')
            if ($('body').hasClass('checkout') && (($quantityValue - 1) == 1)) {
                $(this).attr('disabled', 'disabled')
            }
            if (($quantityValue - 1) < $quantityMax) {
                $(this).parent().find('.btn--plus').removeAttr('disabled')
            }
            if ($quantityValue > 0) {
                $quantity.attr('value', $quantityValue - 1);
                $quantity.val($quantityValue - 1);

                if (($quantityValue - 1) === 0) {
                    $(this).attr('disabled', 'disabled')
                }
                if ($('body').hasClass('checkout')) {
                    let spinner = $(this).parents('.cart-list').find('.shopify-loading');
                    shopifyUpdateQuantity($quantity, $(this).parent().children('.shopify_id'), $(this).parent().children('.cart_line'), spinner);
                }

                if (($quantityValue - 1) == 0 && $('body').hasClass('checkout')) {
                    shopifyRemoveProduct($(this).parent().children('.shopify_id').val(), $(this).parent().children('.cart_line').val(), $(this).parent().children('.shopify_id').val());
                }
            } else {
                $(this).attr('disabled', 'disabled')
                if ($('body').hasClass('checkout')) {
                    shopifyRemoveProduct($(this).parent().children('.shopify_id').val(), $(this).parent().children('.cart_line').val(), $(this).parent().children('.shopify_id').val());
                }
            }
        })
    }

    if ($('.shopify-btn-remove')) {
        $('.shopify-btn-remove').on('click', function () {
            let spinner = $(this).parents('.cart-list').find('.shopify-loading');
            shopifyRemoveProduct($(this).attr('data-shopify-id'), $(this).attr('data-cart-line'), $(this).attr('data-shopify-id'), spinner);
        })
    }

    function shopifyUpdateQuantity(quantity, id, cartLine, $spinner) {
        let routeToken = $("#route_token").val();
        let routeUpdateCart = $("#route_update_cart").val();
        if ($spinner) {
            $spinner.removeClass('d-none');
        }
        $.ajax({
            url: routeToken,
            method: 'GET',
            success: function (data) {
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': data
                    }
                });

                $.ajax({
                    url: routeUpdateCart,
                    method: 'POST',
                    data: {
                        shopify_id: id.val(),
                        quantity: quantity.val(),
                        cartLine: cartLine.val()
                    },
                    success: function (data) {
                        $('.total-price').html(data[1])
                        $('.total-items').text(data[2])
                        $('.cart-notify').text(data[2])
                        $('.shopify-loading').addClass('d-none');
                        if ($spinner) {
                            $spinner.addClass('d-none');
                        }
                    },
                    error: function (data) {
                        $('.shopify-loading').addClass('d-none');
                        if ($spinner) {
                            $spinner.addClass('d-none');
                        }
                    }
                });
            }
        });
    }

    function shopifyRemoveProduct(id, cartLine, shopifyId, $spinner) {
        let routeToken = $("#route_token").val();
        let routeRemoveCart = $("#route_remove_cart").val();
        if ($spinner) {
            $spinner.removeClass('d-none');
        }
        console.log(shopifyId)
        let shopifyIdNumber = shopifyId.split('/').pop();
        $.ajax({
            url: routeToken,
            method: 'GET',
            success: function (data) {
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': data
                    }
                });
                $.ajax({
                    url: routeRemoveCart,
                    method: 'POST',
                    data: {
                        cartLine: cartLine
                    },
                    success: function (data) {
                        $('.total-price').html(data[1])
                        $('.total-items').text(data[2])
                        $('.cart-notify').text(data[2])
                        if (data[2] == 0) {
                            $('.cart-notify').addClass('d-none');
                        }
                        $('#' + shopifyIdNumber).remove()
                        if (!$('.shopify-cartline').length) {
                            $('.shopify-cart-table').remove();
                            $('.empty-cart').removeClass('d-none');
                        }
                        $('.shopify-loading').addClass('d-none');
                        if ($spinner) {
                            $spinner.addClass('d-none');
                        }
                    },
                    error: function (data) {
                        $('.shopify-loading').addClass('d-none');
                        if ($spinner) {
                            $spinner.addClass('d-none');
                        }
                    }
                });
            }
        });
    }


    $('#product-store-link-usa').on('click', function () {
        ga('Account2.send', 'event', {
            'eventCategory': 'findStore',
            'eventAction': 'click',
            'eventLabel': 'Click on Find a store USA'
        });

        fbq('track', 'InitiateCheckout',
            {
                content_ids: [$('#product-store-link-usa').data("product")],
                eventref: 'fb_oea' // or set to empty string
            }
        );
    });

    if (('#ajax-get-quantity').length) {
        let quantityUrl = $('#ajax-get-quantity').val();
        $.ajax({
            url: quantityUrl,
            method: 'GET',
            success: function (data) {
                if (data.length > 0 && data != 0) {
                    $('.cart-notify').removeClass('d-none');
                    $('.cart-notify').text(data);
                }
            }
        });
    }

    /*ga4 tracking click menu*/
    $('.menulv4').on('click', function (e) {
        e.preventDefault()
        var lv4 = ($(this).data('value-lv4')).toLowerCase().replace(/ /g, '_')
        var lv3 = ($(this).data('value-lv3')).toLowerCase().replace(/ /g, '_')
        var lv2 = ($(this).data('value-lv2')).toLowerCase().replace(/ /g, '_')
        var lv1 = ($(this).data('value-lv1')).toLowerCase().replace(/ /g, '_')
        sendTracking(lv1, lv2, lv3, lv4, '', 'click_menu', e)
    });
    $('.menulv3').on('click', function (e) {
        e.preventDefault()
        var lv3 = ($(this).data('value-lv3')).toLowerCase().replace(/ /g, '_')
        var lv2 = ($(this).data('value-lv2')).toLowerCase().replace(/ /g, '_')
        var lv1 = ($(this).data('value-lv1')).toLowerCase().replace(/ /g, '_')
        sendTracking(lv1, lv2, lv3, '', '', 'click_menu', e)
    });
    $('.menulv2').on('click', function (e) {
        e.preventDefault()
        var lv2 = ($(this).data('value-lv2')).toLowerCase().replace(/ /g, '_')
        var lv1 = ($(this).data('value-lv1')).toLowerCase().replace(/ /g, '_')
        sendTracking(lv1, lv2, '', '', '', 'click_menu', e)
    });
    /*end ga4 tracking click menu*/
    /*ga4 tracking click product card*/
    $('.product-tracking').on('click', function (e) {
        e.preventDefault()
        var lv5 = ($(this).data('value-lv5')).toLowerCase().replace(/ /g, '_')
        var lv4 = ($(this).data('value-lv4')).toLowerCase().replace(/ /g, '_')
        var lv3 = ($(this).data('value-lv3')).toLowerCase().replace(/ /g, '_')
        var lv2 = ($(this).data('value-lv2')).toLowerCase().replace(/ /g, '_')
        var lv1 = ($(this).data('value-lv1')).toLowerCase().replace(/ /g, '_')
        sendTracking(lv1, lv2, lv3, lv4, lv5, 'Landing_page_interaction', e)
    });

    /*end ga4 tracking click product*/

    function sendTracking(lv1, lv2, lv3, lv4, lv5, eventName, e) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': eventName,
            'lv1': lv1,
            'lv2': lv2,
            'lv3': lv3,
            'lv4': lv4,
            'lv5': lv5,
        });
        // window.location = e.target.href;
        let anchor = document.createElement('a');
        anchor.href = e.currentTarget.href;
        anchor.target = e.currentTarget.target;
        anchor.click();
        // window.location = e.target.href;
    }

    /**
     * Black Friday Modal
     */
    window.addEventListener('load', () => {
        const blackFridayModal = document.querySelector('#blackFridayModal');
        const sessionStorageLabel = 'shown-black-friday-modal';
        if (blackFridayModal && !sessionStorage.getItem(sessionStorageLabel)) {
            const bsBlackFridayModal = new Modal(blackFridayModal);
            setTimeout(() => {
                bsBlackFridayModal.show();
            }, 2000);
            sessionStorage.setItem(sessionStorageLabel, 'true');
        }
    });

    /**
     * Image comparator
     */
    const imageComparators = document.querySelectorAll('.image-comparator')
    if (imageComparators.length) {
        imageComparators.forEach(el => imageComparator(el))
    }

    /**
     * Landing multipista
     */
    const multipista = document.querySelector('.multipista')
    if (multipista) {
        const images = document.querySelectorAll('.sci-frame img')
        if (images.length) {
            images.forEach((image, i) => image.style.zIndex = images.length - i)

            const container = document.querySelector('.sci-frame')
            const containerHeight = container.getBoundingClientRect().height
            container.style.height = containerHeight + 'px'

            ScrollObserver(images, () => {
                container.style.height = containerHeight + 250 + 'px'

                for (let i = 0; i < 6; i++) {
                    const image = images[i]
                    const offset = -10 + (i * 30)
                    image.style.transform = `translateY(${offset}px)`
                }

                for (let i = 6; i < 13; i++) {
                    const image = images[i]
                    const offset = 10 + (i * 20)
                    image.style.transform = `translateY(${offset}px)`
                }
            }, {rootMargin: "0px 0px -150px 0px", threshold: 1})
        }

        const modalVideo = document.getElementById('modalVideo')
        if (modalVideo) {
            const iframe = modalVideo.querySelector('iframe')
            let src
            const removeSrc = (data) => {
                iframe.setAttribute('data-src', data)
                iframe.removeAttribute('src')
            }

            modalVideo.addEventListener('shown.bs.modal', event => {
                if (!src) src = iframe.src
                iframe.setAttribute('src', src)
                iframe.removeAttribute('data-src')
            })

            modalVideo.addEventListener('hidden.bs.modal', event => removeSrc(src))
        }
    }

    /**
     * Landing Speed Boa
     */
    if (document.body.classList.contains('speed-boa')) {
        let videos = document.querySelectorAll('.speed-boa__video');
        videos.forEach(video => {
            video.addEventListener('mouseover', () => {
                if (video.paused) video.play()
            });

            video.addEventListener('mouseout', () => {
                if (!video.paused) video.pause();
            });
        });
    }

    // UserWay widget position
    document.addEventListener('userway:render_completed', function (event) {
        setTimeout(() => {
            let uwy = document.querySelector('.uwy');
            let userwayButtonsWrapper = uwy?.querySelector('.userway_buttons_wrapper');
            let offset = navigator?.userAgent?.includes("Windows") ? '30' : '14';
            if (userwayButtonsWrapper) userwayButtonsWrapper.style.left = `calc(100vw - ${offset}px)`;
        }, 1000)
    })

    /**
     * Speed BOA Video (mobile)
     * @type {NodeListOf<Element>}
     */
    const speedboaVideoItems = document.querySelectorAll('.speed-boa__video-item');
    if (speedboaVideoItems && speedboaVideoItems.length) {
        ScrollObserver(speedboaVideoItems);
    }
})(jQuery);
